export let isEdit: boolean;

export const setPageMode = (isEditMode: boolean) => {
  isEdit = isEditMode;
};
